import React from "react";
import {
    Modal
} from "react-bootstrap";


export function Collection1(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton></Modal.Header>
            <img
                src={"../img/collection1.png"}
                alt="hey"
                className="img-fluid mb-0 w-100"
            ></img>
        </Modal>
    );
}
export function Collection2(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton></Modal.Header>
            <img
                src={"../img/collection2.png"}
                alt="hey"
                className="img-fluid mb-0 w-100"
            ></img>
        </Modal>
    );
}
export function Collection3(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton></Modal.Header>
            <img
                src={"../img/collection3.png"}
                alt="hey"
                className="img-fluid mb-0 w-100"
            ></img>
        </Modal>
    );
}
export function Collection4(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton></Modal.Header>
            <img
                src={"../img/collection4.png"}
                alt="hey"
                className="img-fluid mb-0 w-100"
            ></img>
        </Modal>
    );
}
export function Collection5(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton></Modal.Header>
            <img
                src={"../img/collection5.png"}
                alt="hey"
                className="img-fluid mb-0 w-100"
            ></img>
        </Modal>
    );
}
